module.exports = __webpack_public_path__ + "static/media/icon-gitlab.aa3da282.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-gitlab.svg
// module id = 517
// module chunks = 0